'use strict';
var bannerPopupService = /** @class */ (function () {
    /*@ngInject*/
    function bannerPopupService($http) {
        'ngInject';
        this.$http = $http;
    }
    bannerPopupService.prototype.getpopUpBannerService = function () {
        return this.$http({
            method: 'GET',
            cache: true,
            url: 'api/content/MarketingBanner'
        });
    };
    return bannerPopupService;
}());
export default bannerPopupService;
//# sourceMappingURL=bannerpopup.service.js.map